import { TranslateService } from '@ngx-translate/core';
import { CommunityProfileWidgetConfig } from '@trp/community/interfaces';

const programOutputs = (
  translateService: TranslateService
): CommunityProfileWidgetConfig['programOutputs'] => ({
  section: 'programOutputs',
  title: 'programMetrics.programOutputs',
  maxColumns: 1,
  propertiesToVerify: [],
  widgets: [],
});

export default programOutputs;